import { useQuery } from '@tanstack/react-query';

import { apiClient, type ArtworkDetail } from '@api';
import { QueryKeys } from '@config';

/**
 * Retrieves a single artwork by id.
 *
 * Required params: artwork id string.
 * Preconditions: user must be authenticated (bearer token via interceptor).
 * Important behavior: query is disabled until artworkID is truthy; supports custom query options.
 *
 * @example
 * const { data: artwork, isPending } = useGetArtwork(artworkId);
 */
export const useGetArtwork = (artworkID: string, options: object = {}) => {
  return useQuery<ArtworkDetail | undefined>({
    queryKey: [QueryKeys.ARTWORKS, artworkID],
    queryFn: async () => {
      const response = await apiClient.artworksRetrieve({
        path: { id: artworkID },
      });
      return response.data;
    },
    enabled: !!artworkID,
    ...options,
  });
};
